import { Component } from '@angular/core';
import { GoogleTagManagerService } from '../../../core/services/google-tag-manager.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-banner',
  imports: [],
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
})
export class BannerComponent {
  promotions: any = null;
  titoloPromo: string | null = null;

  constructor(private gtm: GoogleTagManagerService) {}

  async ngOnInit() {
    const result = await this.getPromotion();
    this.promotions = result;
    this.titoloPromo = result?.body?.titolo;
  }

  onCouponHeaderClick() {
    this.gtm.newEvent('coupon_header_click');
  }

  async getPromotion() {
    try {
      const response = await fetch(
        environment.apiUrl +
          environment.apiVersion +
          '/food/order/promotions/read',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({}),
        }
      );

      if (!response.ok) {
        const errorBody = await response.json();
        throw new Error(errorBody?.message || 'Errore HTTP');
      }

      const data = await response.json();
      console.log('Dati promozione:', data);
      return data;
    } catch (error) {
      console.error('Errore nella richiesta promozione:', error);
      return null;
    }
  }
}
